import http from "@/libs/axios";

export function getApplicationMaterial(params) {
  return http({
    url: "/requirements/requirement_for_good/",
    method: "GET",
    params: params,
  });
}
export function getContractDetail(params) {
  return http({
    url: "/requirements/requirement_for_good/?purchase=true",
    method: "GET",
    params,
  });
}

export function createApplicationMaterial(data) {
  return http({
    method: "POST",
    url: "/requirements/requirement_for_good/",
    data,
  });
}

export function deleteApplicationMaterial(id) {
  return http({
    method: "DELETE",
    url: `/requirements/requirement_for_good/${id}/`,
  });
}

export function getApplicationMaterialId(payload) {
  return http({
    url: `/requirements/requirement_for_good/${payload.id}/`,
    method: "GET",
    params: payload.params,
  });
}

export function updateApplicationMaterial(data) {
  return http({
    url: `/requirements/requirement_for_good/${data.id}`,
    method: "PUT",
    data,
  });
}

export function updatePatchApplicationMaterial(data) {
  return http({
    url: `/requirements/requirement_for_good/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function deleteMaterialInside(id) {
  return http({
    method: "DELETE",
    url: `/requirements/requirement_for_good/${id}/delete_material/`,
  });
}

// instrument
export function createApplicationInstrument(data) {
  return http({
    method: "POST",
    url: "/requirements/requirement_for_instrument/",
    data,
  });
}

export function getApplicationInstrument(query) {
  return http({
    url: "/requirements/requirement_for_instrument/",
    method: "GET",
    params: query,
  });
}

export function deleteApplicationInstrument(id) {
  return http({
    method: "DELETE",
    url: `/requirements/requirement_for_instrument/${id}/`,
  });
}

export function getApplicationInstrumentId(id) {
  return http({
    url: `/requirements/requirement_for_instrument/${id}/`,
    method: "GET",
  });
}

export function updateApplicationInstrument(data) {
  return http({
    url: `/requirements/requirement_for_instrument/${data.id}`,
    method: "PUT",
    data,
  });
}

export function updatePatchApplicationInstrument(data) {
  return http({
    url: `/requirements/requirement_for_instrument/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function deleteInstrumentInside(id) {
  return http({
    method: "DELETE",
    url: `/requirements/requirement_for_instrument/${id}/delete_instrument/`,
  });
}

// transport
export function createApplicationTransport(data) {
  return http({
    method: "POST",
    url: "/requirements/requirement_for_transport/",
    data,
  });
}

export function getApplicationTransport(query) {
  return http({
    url: "/requirements/requirement_for_transport/",
    method: "GET",
    params: query,
  });
}

export function deleteApplicationTransport(id) {
  return http({
    method: "DELETE",
    url: `/requirements/requirement_for_transport/${id}/`,
  });
}

export function getApplicationTransportId(id) {
  return http({
    url: `/requirements/requirement_for_transport/${id}/`,
    method: "GET",
  });
}

export function updateApplicationTransport(data) {
  return http({
    url: `/requirements/requirement_for_transport/${data.id}`,
    method: "PUT",
    data,
  });
}

export function updatePatchApplicationTransport(data) {
  return http({
    url: `/requirements/requirement_for_transport/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function deleteTransportInside(id) {
  return http({
    method: "DELETE",
    url: `/requirements/requirement_for_transport/${id}/delete_transport/`,
  });
}

// status
export function getApplicationStatus(params) {
  return http({
    url: "/knowledge_base/statuses/",
    method: "GET",
    params,
  });
}

// author
export function getApplicationAuthor(params) {
  return http({
    url: "/users/users/",
    method: "GET",
    params,
  });
}

export function getApplicationType(params) {
  return http({
    url: "/storage/storage/",
    method: "GET",
    params,
  });
}

export function getApplicationTimeLine(payload) {
  return http({
    url: "/knowledge_base/status-history/",
    method: "GET",
    params: payload.params,
  });
}

export function getApplicationTimeLineById(payload) {
  return http({
    url: `/knowledge_base/status-history/${payload.id}/with_over_object/`,
    method: "GET",
    params: payload.params,
  });
}

export function updateApplicationMovement(data) {
  return http({
    url: `/movement/movement_for_good/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function createApplicationMovement(data) {
  return http({
    url: "/movement/movement_for_good/",
    method: "POST",
    data,
  });
}

export function createApplicationMovementForInstrument(data) {
  return http({
    url: "/movement/movement_for_instrument/",
    method: "POST",
    data,
  });
}

export function getApplicationMovement(params) {
  return http({
    url: "/movement/movement_for_good/",
    method: "GET",
    params,
  });
}

export function deleteApplicationMovement(id) {
  return http({
    url: `/movement/movement_for_good/${id}`,
    method: "DELETE",
  });
}

export function getOneApplicationMovement(id) {
  return http({
    url: `/movement/movement_for_good/${id}`,
    method: "GET",
  });
}

export function createApplicationInstrumentMovement(data) {
  return http({
    url: "/movement/movement_for_instrument/",
    method: "POST",
    data,
  });
}

export function updateApplicationInstrumentMovement(data) {
  return http({
    url: `/movement/movement_for_instrument/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function getApplicationInstrumentMovement(params) {
  return http({
    url: "/movement/movement_for_instrument/",
    method: "GET",
    params,
  });
}

export function deleteApplicationInstrumentMovement(id) {
  return http({
    url: `/movement/movement_for_instrument/${id}`,
    method: "DELETE",
  });
}

export function getOneApplicationInstrumentMovement(id) {
  return http({
    url: `/movement/movement_for_instrument/${id}`,
    method: "GET",
  });
}

export function getApplicationGoodReturn(params) {
  return http({
    url: "return_off/return_of_good/",
    method: "GET",
    params,
  });
}

export function postForGoodReturn(data) {
  return http({
    url: "return_off/return_of_good/",
    method: "POST",
    data,
  });
}

export function editForGoodReturn({ data, id }) {
  return http({
    url: `return_off/return_of_good/${id}/`,
    method: "PATCH",
    data,
  });
}

export function postForInstrumentsReturn(data) {
  return http({
    url: "/return_off/return_of_instrument/",
    method: "POST",
    data,
  });
}

export function editForInstrumentsReturn({ data, id }) {
  return http({
    url: `/return_off/return_of_instrument/${id}/`,
    method: "PATCH",
    data,
  });
}

export function getOneApplicationGoodReturn(id) {
  return http({
    url: `movement/movement_for_good/to_return/${id}`,
    method: "GET",
  });
}

export function createApplicationGoodReturn(data) {
  return http({
    url: "/movement/movement_for_good/to_return",
    method: "POST",
    data,
  });
}
// get application instrument return list
export function getApplicationInstrumentReturn(params) {
  return http({
    url: "/return_off/return_of_instrument/",
    method: "GET",
    params,
  });
}
export function getOneApplicationInstrumentReturn(id) {
  return http({
    url: `/movement/movement_for_instrument/to_return/${id}`,
    method: "GET",
  });
}
// create application instrument to return
export function createApplicationInstrumentReturn(data) {
  return http({
    url: "/movement/movement_for_instrument/to_return",
    method: "POST",
    data,
  });
}

// update application instrument to return
export function updateApplicationInstrumentReturn(data) {
  return http({
    url: `/movement/movement_for_instrument/to_return/${data.id}`,
    method: "PATCH",
    data,
  });
}

// update application good to return
export function updateApplicationGoodReturn(data) {
  return http({
    url: `/movement/movement_for_good/to_return/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function createWriteOffForGood(data) {
  return http({
    url: `/write_off/write_off_for_good/`,
    method: "POST",
    data: data,
  });
}

export function updateWriteOffForGood(data) {
  return http({
    url: `/write_off/write_off_for_good/${data.id}`,
    method: "PATCH",
    data: data.data,
  });
}
export function updateWriteOffForInstrument(data) {
  return http({
    url: `/write_off/write_off_for_instrument/${data.id}`,
    method: "PATCH",
    data: data.data,
  });
}

export function getWorkerWriteOffForGood(params) {
  return http({
    url: `/write_off/write_off_for_good_of_master/`,
    method: "GET",
    params,
  });
}
export function getWorkerWriteOffForInstrument(params) {
  return http({
    url: `/write_off/write_off_for_instrument_of_master/`,
    method: "GET",
    params,
  });
}

export function getApplicationForBrigadeWorks(params) {
  return http({
    url: `/requirements/requirement_for_brigade/`,
    method: "GET",
    params,
  });
}

export function createApplicationForBrigadeWorks(data) {
  return http({
    url: "/requirements/requirement_for_brigade/",
    method: "POST",
    data,
  });
}

export function getOneApplicationForBrigadeWorks(params) {
  return http({
    url: `/requirements/requirement_for_brigade/${params.id}/`,
    method: "GET",
    params,
  });
}

export function updatePutApplicationForBrigadeWorks(data) {
  return http({
    url: `/requirements/requirement_for_brigade/${data.id}/`,
    method: "PUT",
    data: data.data,
  });
}
export function updatePatchApplicationForBrigadeWorks(data) {
  return http({
    url: `/requirements/requirement_for_brigade/${data.id}/`,
    method: "PATCH",
    data,
  });
}

export function deleteApplicationForBrigadeWorks(data) {
  return http({
    url: `/requirements/requirement_for_brigade/${data}/`,
    method: "DELETE",
  });
}

export function getPartialPaymentForBrigade(params) {
  return http({
    url: `/requirements/requirement_for_brigade_partial_payment/`,
    method: "GET",
    params,
  });
}

export function createPartialPaymentForBrigade(data) {
  return http({
    url: "/requirements/requirement_for_brigade_partial_payment/",
    method: "POST",
    data,
  });
}

export function getOnePartialPaymentForBrigade(params) {
  return http({
    url: `/requirements/requirement_for_brigade_partial_payment/${params.id}/`,
    method: "GET",
    params,
  });
}

export function updatePutPartialPaymentForBrigade(data) {
  return http({
    url: `/requirements/requirement_for_brigade_partial_payment/${data.id}/`,
    method: "PUT",
    data: data.data,
  });
}
export function updatePatchPartialPaymentForBrigade(data) {
  return http({
    url: `/requirements/requirement_for_brigade_partial_payment/${data.id}/`,
    method: "PATCH",
    data,
  });
}

export function deletePartialPaymentForBrigade(data) {
  return http({
    url: `/requirements/requirement_for_brigade_partial_payment/${data}/`,
    method: "DELETE",
  });
}

export function reportRequirementForBrigade(data) {
  if (data && data.blob && data.blob == true) {
    return http({
      url: `/requirements/report/requirement_for_brigade/?excel=${data.excel}`,
      method: "GET",
      responseType: "blob",
    });
  } else {
    return http({
      url: `/requirements/report/requirement_for_brigade/`,
      method: "GET",
      params: data,
    });
  }
}

export function reportRequirementForBrigadeByWorkType(data) {
  if (data && data.blob && data.blob == true) {
    return http({
      url: `/requirements/report/requirement_for_brigade_by_work_type/?excel=${data.excel}`,
      method: "GET",
      responseType: "blob",
    });
  } else {
    return http({
      url: `/requirements/report/requirement_for_brigade_by_work_type/`,
      method: "GET",
    });
  }
}

export function reportRequirementForBrigadeByWorkCategory(data) {
  if (data && data.blob && data.blob == true) {
    return http({
      url: `/requirements/report/requirement_for_brigade_by_work_category/?excel=${data.excel}`,
      method: "GET",
      responseType: "blob",
    });
  } else {
    return http({
      url: `/requirements/report/requirement_for_brigade_by_work_category/`,
      method: "GET",
    });
  }
}

export function reportRequirementForGood(data) {
  if (data && data.blob && data.blob == true) {
    return http({
      url: `/requirements/report/requirement_for_goods/`,
      method: "GET",
      params: data,
      responseType: "blob",
    });
  } else {
    return http({
      url: `/requirements/report/requirement_for_goods/`,
      method: "GET",
      params: data,
    });
  }
}

export function reportRequirementForGoodMaterialType(data) {
  if (data && data.blob && data.blob == true) {
    return http({
      url: `/requirements/report/requirement_for_goods_material_type/`,
      method: "GET",
      params: data,
      responseType: "blob",
    });
  } else {
    return http({
      url: `/requirements/report/requirement_for_goods_material_type/`,
      method: "GET",
      params: data,
    });
  }
}